// extracted by mini-css-extract-plugin
export default {"locationOption":"_3_Rdm","icon":"COluN","text":"_1lcFr","fullText":"_3s6Nn","currentLocationLabel":"_2cPJ0"};